import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const TokenRefreshDialog = ({ open, onRefresh, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="token-refresh-dialog-title"
      aria-describedby="token-refresh-dialog-description"
    >
      <DialogTitle id="token-refresh-dialog-title">
        Session Expiring Soon
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="token-refresh-dialog-description">
          Your session will expire in less than 5 minutes. Would you like to extend your session?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          No
        </Button>
        <Button onClick={onRefresh} color="primary" variant="contained" autoFocus>
          Yes, Extend Session
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenRefreshDialog;